module.exports = __webpack_public_path__ + "img/seagull_logo.e482fc71.jpg";